<template>
  <v-dialog
    v-on="$listeners"
    v-bind="$attrs"
    scrollable
    max-width="1200px"
    transition="dialog-transition"
    :fullscreen="isPrinting"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>

      <v-card-text>
        <m-datatable :headers="errorHeaders" :items="errors" :filters.sync="errorFilters" :isDialog="true">
          <template #item.factor_item_order="{ item }">{{ +item.factor_item_order + 1 }}</template>
          <template #item.factor.code="{ item }">
            <v-btn
              :to="{
                name: 'FactorForm',
                params: { id: item.factor.id, type: item.factor.type, isPreFactor: item.factor.is_pre_factor },
              }"
              rounded
              outlined
              color="blue white--text"
              target="_blank"
              >{{ item.factor.code }}</v-btn
            >
          </template>
          <template #item.inventory="{ item }">
            <open-inventory-btn :wareId="item.ware_id" />
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { FactorTypes } from "@/variables";
import OpenInventoryBtn from "@/components/btns/OpenInventoryBtn";
export default {
  components: { OpenInventoryBtn },
  props: {
    title: {
      required: true,
    },
    errors: {
      required: true,
    },
    errorFilters: {},
  },
  data() {
    return {
      errorHeaders: [
        {
          text: "کالا",
          value: "ware_name",
        },
        {
          text: "انبار",
          value: "warehouse_name",
        },
        {
          text: "نوع فاکتور",
          value: "factor.type",
          items: FactorTypes,
        },
        {
          text: "شماره فاکتور",
          value: "factor.code",
        },
        {
          text: "شماره ردیف فاکتور",
          value: "factor_item_order",
        },
        {
          text: "تعداد کسری",
          value: "count",
        },
        {
          text: "کاردکس",
          value: "inventory",
          sortable: false,
          filterable: false,
          hideInExport: true,
        },
      ],
    };
  },
};
</script>

<style></style>
